import { createFileRoute } from '@tanstack/react-router'
import MarketingModelosWhatsappEditorPage from '@/pages/dashboard/marketing-modelos-whatsapp-editor-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId',
)({
  component: function MarketingModelosWhatsappEditRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingModelosWhatsappEditorPage mode="edit" />
      </RequireModule>
    )
  },
})
